jQuery(function($) {

  //Virtually Maps clicks from our custom Share Icons to addThis Share Buttons
  //NOTE: We are using some vanilla JS in here specifically for compatability with addThis's JS
  $( document ).ready(function() {
    $(".custom-share-button").click(function(ev) {
      //console.log($elem);
      var $button    = $(ev.currentTarget);
      var buttonType = $button.attr('button-type');
      var elemList   = [];
      var baseClass  = window.addThisBaseClass || 'at-svc-';

      elemList = document.getElementsByClassName(baseClass + buttonType);

      console.log('virtual click: ' + baseClass + buttonType);
      console.log(elemList);

      if (elemList[0]) {
        simulateClick(elemList[0]);
      }
    });

    function simulateClick (elem) {
    	// Create our event (with options)
    	var evt = new MouseEvent('click', {
    		bubbles: true,
    		cancelable: true,
    		view: window
    	});
    	// If cancelled, don't dispatch our event
    	var canceled = !elem.dispatchEvent(evt);
    }
  });
});

jQuery(function($) {

  initMobileMenu();

  function initMobileMenu() {
    //Toggle's initial state must be toggle-closed
    $('.toggle-hidden-menu').on('click', function() {
        if(!$(this).hasClass('toggle-opened')) {
          $main_menu = $($('.fbyf-navbar')[0]);
          menu_height = $main_menu.offset().top + $main_menu.height();
          $(this).addClass('toggle-opened').removeClass('toggle-closed');
          $('.hidden-menu').css('top', menu_height);
          $('.burger').toggleClass('burger-x');
          $('body, html').addClass('body-is-mobile');
          $('.hidden-menu.closed').addClass('opened').removeClass('closed');
          $('.fbyf-navbar_mobile').addClass('show-menu');
        }
        else {
          $(this).addClass('toggle-closed').removeClass('toggle-opened');
          $('body, html').removeClass('body-is-mobile');
          $('.burger').toggleClass('burger-x');
          $('.hidden-menu.opened').addClass('closed').removeClass('opened');
          $('.fbyf-navbar_mobile').removeClass('show-menu');
        }
    });

    $('.hidden-menu .menu-item-has-children .fl-menu-toggle').on('click', function (e) {
        $this = $(this);
        $submenu = $this.parent().siblings('.sub-menu');
        if(!$this.hasClass('toggle-opened')){
          $this.addClass('toggle-opened').removeClass('toggle-closed');
          scrollHeight = $submenu[0].scrollHeight;
          $submenu.css( "max-height", scrollHeight );

        } else {
          $this.addClass('toggle-closed').removeClass('toggle-opened');
          $submenu.css( "max-height", "0" );
          console.log('submenu closed');
        }
    });
  }

});

jQuery(function($) {
    
    // Sliders
    if ( $('.fbyf-testimonials-slider').length ) {
        testimonialsSlider();
    }

    // Sermons
    sermonsLoader();
    $('#preacherSort').on('change', filterArchiveSermons);
    $('#seriesSort').on('change', filterArchiveSermons);
    $('#bookSort').on('change', filterArchiveSermons);
    $('#topicSort').on('change', filterArchiveSermons);
    


    function testimonialsSlider() {
        $('.fbyf-testimonials-slider').slick({
            centerMode: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            lazyLoad: 'ondemand',
            speed: 500,
            adaptiveHeight: true,
            fade: true
        });
    }
    // SORTING and ARCHIVE LISTING with PAGINATION
    function sermonsLoader() {
        window.sermonsPage = 2;
  
        $('.load-more-sermons button').click(function() {
            $.ajax({
                type:     'GET',
                url:      '/wp/wp-admin/admin-ajax.php?action=load_sermons&page=' + window.sermonsPage,
                dataType: "json",
                headers: {
                    'Content-Type': 'application/json'
                },
                success: function(data){
                    var $sermons = $('.recent-sermons .sermon-cards');
                    
                    window.sermonsPage++;
                    //console.log(data);

                    if (data && data.body) {
                        $newSermons = data.body;
                        $sermons.append($newSermons);
                    }
        
                    if (data && !data.show_more) {
                        $('.load-more-sermons button').remove();
                        $('.load-more-sermons').append('<p>No more sermons available.</p>');
                    }
                },
                error: function (e) {
                    console.log('Error while fetching more sermons', e);
                }
            });
        });
    }
    // FILTERING
    function filterArchiveSermons() {
        window.sermonsPage = 1;

        var filterSelected = $(this)[0].id;
        var taxonomy = $(this).attr("name");
        var term = $(this).val();

        // console.log(filterSelected);
        // console.log(taxonomy);
        // console.log(term);

        $("select").each(function(){
            var selectID = $(this).attr("id");
            if (selectID != filterSelected) {
                $(this).val( $('#' + selectID + ' option:first').val());
            }
        });

        $.ajax({
            type:     'GET',
            url:      '/wp/wp-admin/admin-ajax.php?action=filter_sermons&taxonomy=' + taxonomy + '&term=' + term + '&page=' +  window.sermonsPage,
            dataType: "json",
            headers: {
                'Content-Type': 'application/json'
            },
            success: function (data) {
                var $sermons = $('.recent-sermons .sermon-cards');
                
                console.log(data);
                window.sermonsPage++;

                if (data && data.body) {
                    $filteredSermons = data.body;
                    $sermons.html($filteredSermons);
                }

                if (data && !data.show_more) {
                    $('.load-more-sermons button').remove();
                }
            },
            error: function (e) {
                console.log('Error while fetching more sermons', e);
            }
        });

        return false;
    }

});

jQuery(function($) {

	initSiteSearch();

	function initSiteSearch() {
		$('.open-search').on('click', function() {
			var $content = $('.hidden-modal--search .search-form');

			setTimeout(function () {
				$.magnificPopup.open({
					removalDelay: 0,
					closeBtnInside: true,
					showCloseBtn: true,
					overflowY: 'scroll',
					mainClass: 'modal__wrapper',
					items: {
					src: $content
					},
					type: 'inline'
				});
			}, 100);

			return false;
		});
	}

});
